<template>
  <div v-if="templateConfig.theme !== 'Operator-Template'">
    <v-card class="templateCard elevation-5">
      <v-card-text>
        <v-layout justify-space-between align-start wrap>
          <CardHeader
            :initialProductName="SubscribeFlowDetails.initialProductName"
            :initialProductPrice="
              SubscribeFlowDetails.selectedOperator.disclaimerParams.price
            "
            :currency="
              SubscribeFlowDetails.selectedOperator.disclaimerParams.currency
            "
          />
          <v-flex
            :xs10="templateConfig.theme === 'Template-A'"
            :md9="templateConfig.theme === 'Template-A'"
            :xs12="templateConfig.theme === 'Template-B'"
          >
            <div style="overflow: hidden">
              <transition mode="out-in">
                <!-- To prevent re-initialize init step in case of go back from "already took" step -->
                <KeepAlive :max="2">
                  <Component :is="SubscribeFlowDetails.component" />
                </KeepAlive>
              </transition>
            </div>
          </v-flex>
          <!-- Vertical stepper start -->
          <v-flex
            :xs2="templateConfig.theme === 'Template-A'"
            :md3="templateConfig.theme === 'Template-A'"
            v-if="
              templateConfig.theme === 'Template-A' ||
              templateConfig.theme === 'Template-B'
            "
          >
            <CustomStepper
              :model="SubscribeFlowDetails.step"
              :steps="3"
              :isVertical="templateConfig.theme === 'Template-A'"
            />
            <PrimaryDisclaimer
              class="primaryDisc"
              v-if="templateConfig.theme === 'Template-B'"
            >
              <div v-html="primaryDisclaimerText"></div>
              <div v-html="enableBackDatedDisclaimerText"></div>
              <div v-html="moCancelationDisclaimerText"></div>
              <div v-html="generalDisclaimerText"></div>
            </PrimaryDisclaimer>
            <template
              v-if="
                !merchantConfig.configs.HideTermsAndConditions &&
                templateConfig.theme === 'Template-B'
              "
            >
              <div class="cardFooter">
                <Terms />
              </div>
            </template>
          </v-flex>
          <!-- Vertical stepper end -->
        </v-layout>
      </v-card-text>
    </v-card>
    <PrimaryDisclaimer
      class="primaryDisc"
      v-if="templateConfig.theme === 'Template-A'"
    >
      <div v-html="primaryDisclaimerText"></div>
      <div v-html="enableBackDatedDisclaimerText"></div>
      <div v-html="moCancelationDisclaimerText"></div>
      <div v-html="generalDisclaimerText"></div>
    </PrimaryDisclaimer>
  </div>

  <!-- Embedded Template-->
  <div
    v-else-if="templateConfig.theme === 'Operator-Template'"
    class="text-center"
  >
    <!-- To prevent re-initialize steps in case of go back from "failure" step -->
    <KeepAlive :max="4">
      <Component :is="SubscribeFlowDetails.component" />
    </KeepAlive>
  </div>
</template>

<script>
//1.General imports.
import { mapState, mapMutations } from 'vuex';
import Terms from '../Shared/components/Terms/terms.vue';

//2.shared comp. imports.
import CardHeader from '../Shared/components/CardHeader.vue';
import CustomStepper from '../Shared/components/custom-stepper.vue';
import PrimaryDisclaimer from '../Shared/components/Disclaimer.vue';
import ExpiredSession from '../Shared/components/ExpiredSession.vue';

//3. Subscription flow components imports.
import SubInit from './stepper-content/Sub-init.vue';
import SubPincode from './stepper-content/Sub-pincode.vue';
import SubSuccess from './stepper-content/Sub-success.vue';
import SubPending from './stepper-content/Sub-pending.vue';
import SubFailure from './stepper-content/Sub-failure.vue';

import SubConfirmationAfterTrial from './stepper-content/Sub-confirmationAfterTrial.vue';

export default {
  props: {
    isRedirectionFlow: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['merchantConfig', 'templateConfig', 'SubscribeFlowDetails']),
    primaryDisclaimerText() {
      let availableData = {
        productName: this.SubscribeFlowDetails.initialProductName,
        price:
          this.SubscribeFlowDetails.selectedOperator.disclaimerParams.price,
        currency:
          this.SubscribeFlowDetails.selectedOperator.disclaimerParams.currency,
        frequency: this.SubscribeFlowDetails.frequency,
      };
      switch (this.SubscribeFlowDetails.component) {
        case 'SubInit':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.initPrimaryDisclaimer,
            availableData
          );
        case 'SubPincode':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.pinCodePrimaryDislcaimer,
            availableData
          );
        case 'SubSuccess':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.successPrimaryDisclaimer,
            availableData
          );
        case 'SubFailure': //double check if it exist and need place holders or not.
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.failurePrimaryDisclaimer;
        case 'SubConfirmationAfterTrial':
          //Needs $replacePlaceholders plugin function for
          //[productName, price, currency, frequency] placeholders.
          return this.$replacePlaceholders(
            this.merchantConfig.texts.afterTrialPrimaryDisclaimer,
            availableData
          );
        default:
          return '';
      }
    },
    enableBackDatedDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.SubscribeFlowDetails.selectedOperator.disclaimerParams
        .enableBackDatedCollection
        ? this.merchantConfig.texts.enableBackDatedDisclaimer
        : '';
    },
    moCancelationDisclaimerText() {
      //Needs $replacePlaceholders plugin function for
      //[cancelKeyword, cancelShortCode] placeholders.
      
      if (Object.keys(this.SubscribeFlowDetails.selectedOperator.disclaimerParams).length === 0) {
        return "";
      }

      return this.$replacePlaceholders(
        this.merchantConfig.texts.moCancelationDisclaimer,
        {
          cancelShortCode:
            this.SubscribeFlowDetails.selectedOperator.disclaimerParams
              .cancelationShortCode,
          cancelKeyword:
            this.SubscribeFlowDetails.selectedOperator.disclaimerParams
              .cancelationKeyword,
        }
      );
    },
    generalDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.generalDisclaimer;
    },
  },
  components: {
    CardHeader,
    CustomStepper,
    PrimaryDisclaimer,
    Terms,
    SubInit,
    SubPincode,
    SubSuccess,
    SubPending,
    SubFailure,
    SubConfirmationAfterTrial,
    ExpiredSession
  },
  methods: {
    ...mapMutations(['setSubscribeFlowDetails', 'setMerchantConfig']),
    injectScript(url){
      const script = document.createElement('script');
      script.src = url;
      document.head.appendChild(script);
    }
  },

  async created() {
    this.$http.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          this.setSubscribeFlowDetails({
            step: 3,
            component: 'ExpiredSession',
            operationStatusCode: 401,
          });
        }
        return Promise.reject(error);
      }
    );

    let response = await this.$http.get(`/sub/GetSubscriptionProductDetails?merchantId=${this.merchantConfig.merchantId}`);
    /*========= response object Template ========== */
    // let response = {
    //   data: {
    //     allowMultipleFreeStartPeriods: true,
    //     autoRenewContract: true,
    //     catalogName: 'HETest',
    //     customerAccountNumber: 'CustomerAccount180521',
    //     freeStartPeriod: null,
    //     freeTrialDays: 0,
    //     frequency: 'daily',
    //     initialProductName: '100 Points',
    //     initialProductSKU: '100Points',
    //     msisdn: '201270240983',
    //     numberOfFreeTrials: null,
    //     operatorCode: '60201',
    //     parkingPeriod: 10,
    //     postFreeTrialInitialCharge: true,
    //     postFreeTrialParkingHrs: null,
    //     recurringProductSKU: '100Points',
    //     redirectUrl: 'https://www.nour-redirect.com',
    //     subscriptionPlanId: 3,
    //     subscriptionType: 2,
    //     subscriptionTypeName: 'Daily Subscription 2 X 10 Hours Trials',
    //   },
    // };
    /*============================================= */
    this.injectScript(response.data.subscriptionServiceClientUrl);
    // add missing MSISDN and operator from cached values.
    let operatorCode = response.data.operatorCode
      ? response.data.operatorCode
      : localStorage.getItem('operatorCode');
    let msisdn = response.data.msisdn
      ? response.data.msisdn
      : localStorage.getItem('msisdn');

    this.setSubscribeFlowDetails({ ...response.data, msisdn, operatorCode });

    //override country to be editable incase no operatorcode
    if (!response.data.operatorCode) {
      let tempMerchantConfig = this.merchantConfig;
      tempMerchantConfig.fields[0].isEditable = true;
      this.setMerchantConfig(tempMerchantConfig);
    }

    //set the step
    if (this.isRedirectionFlow) {
      if (this.$route.params.paymentStatus == 'error') {
        this.setSubscribeFlowDetails({
          step: 4,
          component: 'SubFailure',
          failureMessage: this.$translate('GENERALFAILUREMESSAGE'),
          operationStatusCode: '51',
          errorMessage: 'Subscription Failed',
        });
      } else if (this.$route.params.paymentStatus == 'success') {
        this.setSubscribeFlowDetails({
          step: 3,
          component: 'SubSuccess',
          paymentId: this.$route.params.paymentId,
        });
      } else if (this.$route.params.paymentStatus == 'pending') {
        this.setSubscribeFlowDetails({
          step: 3,
          component: 'SubPending',
        });
      }
    } else {
      this.setSubscribeFlowDetails({ step: 1, component: 'SubInit' });
    }
  },
};
</script>
